import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const LockerWrapper = (props: any) => {
  const { disabled, ...rest } = props?.children?.props
  const { lockedById } = useSelector((state: RootState) => state.patient)
  const { userSession } = useSelector((state: RootState) => state.userSession)

  const isPatientLocked = lockedById && lockedById !== userSession.id && lockedById !== ''

  return (
    <props.children.type {...rest} disabled={disabled || isPatientLocked}></props.children.type>
  )
}

export default LockerWrapper
